import Ajax from '../lib/ajax';

// 售后业务部分
// 导入计划表
// 查询售后业务导入计划表的数据
export const getPostSaleInitData = params => Ajax.get('/api/services/app/SceneImportRecord/QueryDto', { params });
//  初始化下拉框数据
export const getPostSaleInitInfo = () => Ajax.get('/api/services/app/SceneImportRecord/GetMgrInitData');
// 确认选人
export const chooseUser = params => Ajax.post(`/api/services/app/SceneImportRecord/SaveSceneData?SceneImportRecordId=${params.SceneImportRecordId}&SalesPersonId=${params.SalesPersonId}`);
// 确认选人
export const donePlan = params => Ajax.post(`/api/services/app/SceneImportRecord/ConfirmSceneImportRecord?SceneImportRecordId=${params.SceneImportRecordId}`);

// 计划表查询
// 查询售后业务计划表查询的数据
export const getPostSaleListInitData = params => Ajax.get('/api/services/app/SceneDataItem/QueryDto', { params });
//  初始化下拉框数据
export const getPostSaleListInitInfo = () => Ajax.get('/api/services/app/SceneDataItem/GetMgrInitData');

// 查询导入配置计划表的数据
export const getConfiguration = params => Ajax.get('/api/services/app/PartsImportRecord/QueryDto', { params });
//  初始化下拉框数据
export const getConfigurationInfo = () => Ajax.get('/api/services/app/PartsImportRecord/GetMgrInitData2');

// 查询配置计划表的是即开
export const getConfigurationList = params => Ajax.get('/api/services/app/PartsDataItem/QueryDto', { params });
//  初始化下拉框数据
export const getConfigurationListInfo = () => Ajax.get('/api/services/app/PartsDataItem/GetMgrInitData');

// 客户管理页面
// 获取客户信息
export const getCustomersAndContact = params => Ajax.get('/api/services/app/SHB_Customer/QueryDto', { params });
// 获取单个客户信息
export const getCustomerById = params => Ajax.get('/api/services/app/SHB_Customer/GetCustomerByGuid', { params });
// 获取单个客户所有信息
export const getAllCustomerById = params => Ajax.get('/api/services/app/SHB_Customer/GetCustomerAllInfoByGuid', { params });
// 修改客户信息
export const updateCustomer = (params) => Ajax.put('/api/services/app/SHB_Customer/UpdateCustomer', params);
// 新增客户
export const createCustomer = (params) => Ajax.post('/api/services/app/SHB_Customer/SavaCustomer', params);
// 删除客户
export const removeCustomer = params => Ajax.delete(`/api/services/app/SHB_Customer/Delete?Id=${params}`);
// 转换为正式客户
export const changeCustomerType = (params) => Ajax.post('/api/services/app/SHB_Customer/ChangeCustomerType', params);
// 提交客户营业执照审核
export const submitCustomerBusinessLicenseExamine = params => Ajax.post(`/api/services/app/SHB_Customer/SubmitCustomerBusinessLicenseExamine?Id=${params}`);
// 提交客户组织架构图审核
export const submitCustomerOrganizationChartExamine = params => Ajax.post(`/api/services/app/SHB_Customer/SubmitCustomerOrganizationChartExamine?Id=${params}`);
// 提交客户财务人员审核
export const submitCustomerExamine = params => Ajax.post(`/api/services/app/SHB_Customer/SubmitCustomerExamine?Id=${params}`);
// 提交客户执行董事审核
export const submitCustomerDirectorExamine = params => Ajax.post(`/api/services/app/SHB_Customer/SubmitCustomerDirectorExamine?Id=${params}`);

// 审核客户营业执照
export const customerBusinessLicenseExamine = (params) => Ajax.post('/api/services/app/SHB_Customer/CustomerBusinessLicenseExamine', params);
// 审核客户组织架构图
export const customerOrganizationChartExamine = (params) => Ajax.post('/api/services/app/SHB_Customer/CustomerOrganizationChartExamine', params);
// 财务审核客户
export const customerExamine = (params) => Ajax.post('/api/services/app/SHB_Customer/CustomerExamine', params);
// 执行董事审核客户
export const customerDirectorExamine = (params) => Ajax.post('/api/services/app/SHB_Customer/CustomerDirectorExamine', params);
// 审核客户营业执照不通过
export const customerBusinessLicenseExamineNoPass = (params) => Ajax.post('/api/services/app/SHB_Customer/CustomerBusinessLicenseExamineNoPass', params);
// 审核客户组织架构图不通过
export const customerOrganizationChartExamineNoPass = (params) => Ajax.post('/api/services/app/SHB_Customer/CustomerOrganizationChartExamineNoPass', params);
// 财务审核客户不通过
export const customerExamineNoPass = (params) => Ajax.post('/api/services/app/SHB_Customer/CustomerExamineNoPass', params);
// 执行董事审核客户不通过
export const customerDirectorExamineNoPass = (params) => Ajax.post('/api/services/app/SHB_Customer/CustomerDirectorExamineNoPass', params);

// 获取联系人
export const getContactById = params => Ajax.get('/api/services/app/SHB_Customer/GetCustomerContactsByGuid', { params });
// 修改联系人
export const updateContact = params => Ajax.put('/api/services/app/SHB_Customer/UpdateCustomerContacts', params);
// 新增联系人
export const createContact = params => Ajax.post('/api/services/app/SHB_Customer/SavaCustomerContacts', params);
// 删除联系人
export const removeContact = params => Ajax.delete(`/api/services/app/SHB_Customer/DeleteCustomerContacts?Id=${params}`);
// 获取所有业务员
export const getYWY = params => Ajax.get('/api/services/app/SHB_Customer/GetMgrInitData', { params });

//获取客户走访计划
export const getCustomerInterviewPlanList = params => Ajax.get('/api/services/app/CustomerInterviewPlanApiService/QueryDto', { params });
// 获取客户走访计划详情
export const getCustomerInterviewPlanById = params => Ajax.get('/api/services/app/CustomerInterviewPlanApiService/GetDetailById', { params });
// 获取客户走访计划详情及操作日志
export const getCustomerInterviewPlanDetailInfoById = params => Ajax.get('/api/services/app/CustomerInterviewPlanApiService/GetDetailInfoById', { params });
// 修改客户走访计划
export const updateCustomerInterviewPlan = (params) => Ajax.put('/api/services/app/CustomerInterviewPlanApiService/Update', params);
// 新增客户走访计划
export const createCustomerInterviewPlan = (params) => Ajax.post('/api/services/app/CustomerInterviewPlanApiService/Create', params);
// 删除客户走访计划
export const removeCustomerInterviewPlan = params => Ajax.delete(`/api/services/app/CustomerInterviewPlanApiService/Delete?Id=${params}`);

//获取客户走访记录
export const getCustomerInterviewRecordList = params => Ajax.get('/api/services/app/CustomerInterviewRecordApiService/QueryDto', { params });
// 获取客户走访记录详情
export const getCustomerInterviewRecordById = params => Ajax.get('/api/services/app/CustomerInterviewRecordApiService/GetDetailById', { params });
// 获取客户走访计录详情及操作日志
export const getCustomerInterviewRecordDetailInfoById = params => Ajax.get('/api/services/app/CustomerInterviewRecordApiService/GetDetailInfoById', { params });
// 修改客户走访记录
export const updateCustomerInterviewRecord = (params) => Ajax.put('/api/services/app/CustomerInterviewRecordApiService/Update', params);
// 新增客户走访记录
export const createCustomerInterviewRecord = (params) => Ajax.post('/api/services/app/CustomerInterviewRecordApiService/Create', params);
// 删除客户走访记录
export const removeCustomerInterviewRecord = params => Ajax.delete(`/api/services/app/CustomerInterviewRecordApiService/Delete?Id=${params}`);

//获取客户销售费用预算
export const getCustomerSalesExpenseBudgetList = params => Ajax.get('/api/services/app/CustomerSalesExpenseBudgetApiService/QueryDto', { params });
// 获取客户销售费用预算详情
export const getCustomerSalesExpenseBudgetById = params => Ajax.get('/api/services/app/CustomerSalesExpenseBudgetApiService/GetDetailById', { params });
// 获取销售费用预算详情及操作日志
export const getCustomerSalesExpenseBudgetDetailInfoById = params => Ajax.get('/api/services/app/CustomerSalesExpenseBudgetApiService/GetDetailInfoById', { params });
// 修改客户销售费用预算
export const updateCustomerSalesExpenseBudget = (params) => Ajax.put('/api/services/app/CustomerSalesExpenseBudgetApiService/Update', params);
// 新增客户销售费用预算
export const createCustomerSalesExpenseBudget = (params) => Ajax.post('/api/services/app/CustomerSalesExpenseBudgetApiService/Create', params);
// 删除客户销售费用预算
export const removeCustomerSalesExpenseBudget = params => Ajax.delete(`/api/services/app/CustomerSalesExpenseBudgetApiService/Delete?Id=${params}`);


// 外协公司管理
// 获取外协公司
export const getOutPerson = params => Ajax.get('/api/services/app/User/QueryDto', { params });

//获取售后所有人员
export const getAfterPerson = () => Ajax.get('/api/services/app/SceneDataItem/GetUserList');

// 修改外协公司信息
export const updateOutPerson = params => Ajax.put('/api/services/app/User/UpdateAfterSalesPersonnel', params);
// 新增外协公司
export const createOutPerson = params => Ajax.post('/api/services/app/User/CreateAfterSalesPersonnel', params);
// 删除外协公司
export const removeOutPerson = params => Ajax.delete(`/api/services/app/User/Delete?Id=${params}`);
// 根据guid获取数据
export const getOutPersonById = params => Ajax.get('/api/services/app/User/GetAfterSalesPersonnelById', { params });

// 确认发货
export const confirmDelivery = params => Ajax.post('/api/services/app/SceneDataItem/ConfirmDelivery', params);
//获取所有售后人员及经理
export const getafterSalePerson = () => Ajax.get('/api/services/app/SHB_OutsideAssist/GetAllAfterSalePersonAndManager');
//分配售后人员
export const distributionAfterSalePerson = (params) => Ajax.post(`/api/services/app/SceneDataItem/DistributionAfterSalePerson?guid=${params.guid}&taskId=${params.taskId}&afterSalePersonId=${params.afterSalePersonId}&managerUserId=${params.managerUserId}`);
//获取售后详情
export const getDetailByGuid = (params) => Ajax.get(`/api/services/app/SceneDataItem/GetDetailByGuid`, { params });
//新增模具
export const createDie = (params) => Ajax.post(`/api/services/app/SceneDataItem/CreateDataItem`, params);
//获取售后类型
export const getAfterSaleType = () => Ajax.get(`/api/services/app/SceneDataItem/GetSHTypeInitData`);
//创建任务
export const createTest = (params) => Ajax.post(`api/services/app/SceneDataItem/WorkFlow_新增任务`, params);
//获取模具任务列表/api​/services​/app​/SceneDataItemTask​/QueryDto
export const getTeskList = (params) => Ajax.get('api/services/app/SceneDataItemTask/QueryDto', { params });
//获取用户权限
export const getRoles = () => Ajax.get('api/services/app/User/GetRoles');
//获取客户名称
export const getCustomers = (params) => Ajax.get(`/api/services/app/SceneDataItem/GetCustomers`, {params});

//考勤管理_查询人员
export const getPersonnelListData = (params) => Ajax.get('api/services/app/User/QueryDto_Attendance', { params });
//考勤管理_获取人员详情
export const getPersonnelById = (params) => Ajax.get(`/api/services/app/User/GetUserDetail`, { params });
//考勤管理_修改人员
export const updatePersonnel = (params) => Ajax.post(`api/services/app/User/UpdateUser_Attendance`, params);

//考勤管理_考勤管理
export const getAttendanceListData = (params) => Ajax.get('/api/services/app/AttendanceRecord/QueryDto', { params });

//考勤管理_查询假期管理
export const getLeaveListData = (params) => Ajax.get('/api/services/app/Leave/QueryDto', { params });
//考勤管理_获取人员下拉框
export const getUserNames = (params) => Ajax.get(`/api/services/app/Leave/GetUserNames`, {params:{ name: params }});
//考勤管理_加班获取人员下拉框
export const getOverTimeUserNames = (params) => Ajax.get(`/api/services/app/OverTimeLeave/GetUserNames`, {params:{ name: params }});
//考勤管理_审核请假通过
export const examineLeave = params => Ajax.post('/api/services/app/Leave/ExamineLeave', params);
//考勤管理_审核请假不通过
export const examineLeaveNoPass = params => Ajax.post('/api/services/app/Leave/ExamineLeaveNoPass', params);

//考勤管理_查询加班管理
export const getOverTimeLeaveListData = (params) => Ajax.get('/api/services/app/OverTimeLeave/QueryDto', { params });
//考勤管理_审核加班通过
export const examineOverTimeLeave = params => Ajax.post('/api/services/app/OverTimeLeave/ExamineLeave', params);
//考勤管理_审核加班不通过
export const examineOverTimeLeaveNoPass = params => Ajax.post('/api/services/app/OverTimeLeave/ExamineLeaveNoPass', params);

//考勤管理_核销去年结余假期
export const resetLastYearUserLeave = params => Ajax.post('/api/services/app/UserLeave/ResetLastYearUserLeave');
